<template>
  <div>
    <div>
      <b-breadcrumb :items="navigationItems" />
      <b-container>
        <h3>Configuration for {{ paymentType }} with ID {{ paymentId }}</h3>
        <edit-alternative-payment-item
          :payment-type="paymentType"
          :payment-id="paymentId"
          :client-id="clientId"
          :configuration-id="configurationId"
        />
      </b-container>
    </div>
  </div>
</template>
<script>
import EditAlternativePaymentItem from '../templates/EditAlternativePaymentItem'

export default {
  name: 'AltPaymentsConfiguration',
  components: {
    EditAlternativePaymentItem
  },
  data() {
    return {
      navigationItems: [{
        text: 'Home',
        to: { name: 'home' }
      }, {
        text: 'Payments Widget',
        to: { name: 'client' }
      }, {
        text: 'Configurations',
        to: { name: 'configuration' }
      }, {
        text: 'Alternative Payments',
        to: {
          name: 'alternativePayments',
          params: {
            clientId: this.$route.params.clientId
          }
        }
      }, {
        text: 'Edit Alternative Payment',
        active: true
      }],
      clientId: this.$route.params.clientId,
      configurationId: this.$route.params.configurationId,
      paymentId: this.$route.params.paymentId,
      paymentType: this.$route.params.paymentType
    }
  },
  created() {
  }
}
</script>
